import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import {
  ErrorHandler,
  Inject,
  Injectable,
  Optional,
  PLATFORM_ID,
} from '@angular/core';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Response } from 'express';
import { ErrorTracking } from './error-tracking.service';

@Injectable()
export class CustomErrorHandler extends ErrorHandler {
  isBrowser: boolean;

  constructor(
    private errorTracking: ErrorTracking,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(RESPONSE) private response: Response,
  ) {
    super();
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  handleError(error: any): void {
    // When on the server, abort & return a 500
    if (isPlatformServer(this.platformId)) {
      this.response.status(500);
      this.response.locals.error = error.rejection ? error.rejection : error;
      return;
    }
    // When on the browser, report to Sentry
    this.errorTracking.captureException(error.originalError || error);
    // Angular's native error handler breaks WebDriverJS console read API.
    // FIXME: detect Protractor env better
    if (
      isPlatformBrowser(this.platformId) &&
      window.location.host === 'localhost:5000'
    ) {
      console.error(error);
    } else {
      super.handleError(error);
    }
  }
}
